import React, { useCallback } from 'react';
import sdk from 'sdk';
import { useCakeDispatch } from 'app/store';
import { getVoucherState } from 'voucher/VoucherSelector';
import { useCakeSelector } from 'app/rootReducer';
import { setVoucherCodeInLocal, setVoucherLoading } from 'voucher/voucherSlice';
import { reloadUser } from 'user/userSlice';
import { Trans } from 'react-i18next';

const useRedeem = () => {
  const dispatch = useCakeDispatch();
  const { voucherCode } = useCakeSelector(getVoucherState);

  const checkAndRedeemVoucher = useCallback(async () => {
    if (!voucherCode) {
      return;
    }

    try {
      dispatch(setVoucherLoading(true));
      await sdk.VoucherInfoApi.redeem(voucherCode);
      dispatch(setVoucherCodeInLocal({ code: '' }));
      await dispatch(reloadUser());
      dispatch(setVoucherLoading(false));
    } catch (err) {
      const { message } = err;
      window.cakepool.showAlert('error', <span><Trans>Error attempting to redeem voucher</Trans>: <Trans>{message}</Trans></span>);
      dispatch(setVoucherLoading(false));
    }
  }, [dispatch, voucherCode]);

  return { checkAndRedeemVoucher };
};

export default useRedeem;
